import React, { useState, useEffect, useRef } from 'react';
import Container from '../../layouts/Container/Container'
import LoginForm from '../organisms/LoginForm'
import Slider from 'react-slick';
import useWidth from '../../hooks/useWidth'
import Icon from '../atoms/Icon'
// import Preloader from '../atoms/Preloader';
import { sendDataLayer } from "../../utils/functions";

function Login({
  autologin,
  hash,
  link
}) {
  const sliderRef = useRef(null)
  const { width } = useWidth();
  const [tabIndex, setTabIndex] = useState(0);
  const [isFirstSlide, setIsFirstSlide] = useState(true)
  const [isLastSlide, setIsLastSlide] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  // const [extraLoginPreloader, setExtraLoginPreloader] = useState(false)

  console.log("isFirstSlide", isFirstSlide)
  console.log("isLastSlide", isLastSlide)
  
  const tabs = [
    {
      label: 'Ingresa',
      image: '/assets/images/Avatar_Man.svg',
      image_active: '/assets/images/Avatar_Man_active.svg'
    },
    {
      label: '¿Cómo participar?',
      image: '/assets/images/maletin.svg',
      image_active: '/assets/images/maletin_active.svg'
    }
  ]

  const sliderStepsSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    variableWidth: true
  }

  const slidesSteps = [
    {
      title: 'Inscríbete',
      number: '1',
      desc: "Participa ingresando con tu código enviado por correo o <strong>solicitándolo por WhatsApp: <a href='https://wa.link/cin3ky' target='_blank' rel='noreferrer'>Éxito</a> o <a href='https://wa.link/5ls8e7' target='_blank' rel='noreferrer'>Carulla</a>,</strong> junto con tu fecha de nacimiento.",
    },
    {
      title: 'Cumple tus metas ',
      number: '2',
      desc: 'Tendrás dos metas. Una de compras en <b>almacenes Éxito o Carulla</b> y otra en <b>otros comercios</b>. Al cumplirlas, participas por los premios.',
    },
    {
      title: '¡Gana uno de los 70 premios!',
      number: '3',
      desc: 'Quien más compras realice en otros comercios <b>gana un Renault Kwid 0 km</b>. Los otros lugares se llevan premios increíbles.',
    },
  ]

  // === Datos de premios (mismos que ya usas) ===

  const list = [
    {
      id: 0,
      title: 'Primer lugar',
      desc: 'Tu próxima parada puede ser en tu nuevo carro! Estrena un <b>Renault Kwid.</b>',
      img: '../images/sli1.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 1,
      title: 'Segundo lugar',
      desc: 'Recorre la ciudad o aventúrate fuera de ella, estrena una moto <b>Hero Xpulse.<b> ',
      img: '../images/sli2.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 2,
      title: 'Tercer lugar',
      desc: '<b>Llévate un kit Apple Lover:</b> iPhone 16e 128GB Black, AirPods (4ta Gen) con Case de Carga USB-C, Apple Watch SE 3(GPS) 44mm -Medianoche - Correa Deportiva Medianoche (M/L).',
      img: '../images/sli3.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 3,
      title: 'Cuarto lugar',
      desc: '<b>Disfruta un bono de viaje Éxito por $5 millones</b> para vivir la aventura que tú elijas.',
      img: '../images/sli4.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 4,
      title: 'Quinto lugar',
      desc: '<b>Gana un bono Éxito por $5 millones</b> y úsalo en lo que más te guste.',
      img: '../images/sli5.png',
      location: 'Sudáfrica',
      benefits: []
    },
    {
      id: 5,
      title: 'Sexto lugar en adelante',
      desc: '65 bonos Éxito, cargados con <b>$150.000.</b>',
      img: '../images/sli6.png',
      location: 'Sudáfrica',
      benefits: []
    }
  ]

  const CustomPrevArrow = ({ onClick }) => (
    <button
      onClick={() => {
        const currentSlide = sliderRef.current?.innerSlider?.state?.currentSlide || 0;

        sendDataLayer({ datalayer: { event: 'carousel_navigation', text: 'Comercios con beneficios por tener una Tarjeta Mastercard', position: currentSlide.toString() }, repeat: true })
        if (onClick) {
          onClick();
        }

      }}
      className="custom-prev"
    ><img src="assets/images/left.png" alt="" /></button>
  );

  const CustomNextArrow = ({ onClick, disabled }) => (
    <button
      onClick={() => {
        if (disabled) return; // BLOQUEA EL CLICK

        const currentSlide = sliderRef.current?.innerSlider?.state?.currentSlide || 0;
        const currentSlideNext = currentSlide + 2;

        sendDataLayer({
          datalayer: {
            event: 'carousel_navigation',
            text: 'Comercios con beneficios por tener una Tarjeta Mastercard',
            position: currentSlideNext.toString()
          },
          repeat: true
        });

        if (onClick) onClick();
      }}
      className={`custom-next ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
    >
      <img src="assets/images/left.png" alt="" />
    </button>
  );

  const settings = {
    className: "center",
    // centerMode: true, 
    centerPadding: "0px",
    slidesToShow: 1,
    initialSlide: 0,
    speed: 500,
    variableWidth: true,
    focusOnSelect: true,
    dots: true,
    infinite: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    afterChange: (current) => {
      const total = list.length;

      sendDataLayer({datalayer: {event: "carousel_navigation",text: "Descubre todo lo que puedes ganar",page_url: window.location.href, position: (current + 1)}, repeat: true});

      setIsFirstSlide(current === 0);
      setIsLastSlide(current >= total - 1);
    },
    beforeChange: (_, next) => {
      const total = sliderRef.current?.innerSlider?.state?.slideCount || 0;
      setIsFirstSlide(next === 0);
      setIsLastSlide(next >= total - 1);
    },
    accessibility: false

  };


  useEffect(() => {
    const handleClick = (event) => {
      const element = event.target;
      const isSlickDot = element.closest('.slick-dots li');
      if (isSlickDot !== null) {
        sendDataLayer({ datalayer: { event: "carousel_navigation", text: "Gana asi", position: event.target.textContent, site_url: window.location.href }, repeat: true });
      } else {
        const btn = element.classList.contains('awards__btn') ? element : element.closest('.awards__btn');
        if (!btn) return;

        if (btn.classList.contains('awards__btn--next')) {
          sendDataLayer({
            datalayer: {
              event: "carousel_navigation",
              text: "Descubre todo lo que puedes ganar",
              position: 1,
              site_url: window.location.href
            },
            repeat: true
          });
        } else if (btn.classList.contains('awards__btn--prev')) {
          sendDataLayer({
            datalayer: {
              event: "carousel_navigation",
              text: "Descubre todo lo que puedes ganar",
              position: 0,
              site_url: window.location.href
            },
            repeat: true
          });
        }
      }
    };
    document.addEventListener('click', handleClick, true);
  }, []);

  const handleTabClick = (idx, tab) => {
    sendDataLayer({ datalayer: { event: 'access_options', text: tab.label }, repeat: true })
    setTabIndex(idx);
  }

  const handleClick = () => {
    sendDataLayer({ datalayer: { event: "how_to_win_register" }, repeat: true });
    setTabIndex(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  }

  useEffect(() => {
    // === CONFIGURACIÓN: a cuál link del footer quieres redirigir el click ===
    const FOOTER_LINK_INDEX = 0; // 0 = primer link, 1 = segundo, etc.
    // O si prefieres por texto exacto (deja en "" para ignorar):
    const FOOTER_LINK_TEXT = ""; // por ejemplo: "Términos y condiciones"

    const clickProxy = (ev) => {
      // Sólo nos interesa el <a> dentro del bloque .terms
      const anchor = ev.target.closest('.mc-input-container__box.terms a');
      if (!anchor) return;

      ev.preventDefault(); // evita navegar el "#" original

      // Busca la lista del footer
      const list = document.querySelector('.mc-footer-container__section--links');
      if (!list) return;

      // Obtén todos los <a> del footer
      const footerLinks = Array.from(list.querySelectorAll('a'));

      // Selecciona por texto o por índice
      let targetLink = null;
      if (FOOTER_LINK_TEXT) {
        targetLink = footerLinks.find(a => a.textContent.trim() === FOOTER_LINK_TEXT.trim()) || null;
      }
      if (!targetLink) {
        targetLink = footerLinks[FOOTER_LINK_INDEX] || null;
      }
      if (!targetLink) return;

      // Dispara el onClick de React del footer (para que pase por tus handlers/analytics)
      targetLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    };

    // Delegación a nivel de documento para capturar el click en el <a> del bloque .terms
    document.addEventListener('click', clickProxy, true);
    return () => {
      document.removeEventListener('click', clickProxy, true);
    };
  }, []);

  const scroll = () => {
    const sliderElement = document.querySelector('#login-slider')
    if (sliderElement) {
      const sliderPosition = sliderElement.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({ top: sliderPosition, left: 0, behavior: 'smooth' })
    }
  }
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 62)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])


  return (
    <div className='mc-page login slow_ani'>

      <div className={`mc-login__container  ${scrolled ? 'static_banner_container' : ''}`} >
        {width > 992
          ? <>
            <Container>
              <div className='login-form-container '>
                <h1>
                  <span className='span-type-1'>Para tooodo lo que quieres</span>
                  <span className='span-type-2'>usa tu Tarjeta Éxito</span>
                  <span className='span-type-2'>o Carulla Mastercard</span>
                  {/* <span className='span-type-2'>Carulla Mastercard</span> */}
                </h1>
                <img src={`/assets/images/btn_scroll.png`} alt="Scroll down" className='btn_scroll' onClick={scroll}/>
                <div className='tabs-login-container'>
                  <div className='tabs-container'>
                    <section className="section-tab-login">
                      <article>
                        <div className="tab items">
                          {tabs.map((tab, idx) => (
                            <div
                              key={tab.label}
                              className={`tab-item ${tabIndex === idx ? 'active' : ''}`}
                              onClick={() => handleTabClick(idx, tab)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') handleTabClick(tab.key);
                              }}
                              aria-selected={tabIndex === idx}
                            >
                              {tab.image
                                ? <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                  <img src={tabIndex === idx ? tab.image_active : tab.image} alt={`${tab.label} icon`} /> {tab.label}
                                </h3>
                                : <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                  {tab.label}
                                </h3>
                              }

                            </div>
                          ))}
                        </div>
                      </article>
                    </section>
                  </div>
                  {tabIndex === 0 &&
                    <LoginForm
                      title={"¡Ingresa y participa!"}
                      type="credentials"
                      fields={[
                        { field: "code", label: "Introduce el código recibido por correo", placeholder: "Escribe tu código de 6 digitos ", maxlength: 6, separated: false,  tooltip: "<strong>¿Dónde encuentro mi código?</strong><br/>Revisa tu correo o celular para encontrar el código de ingreso." },
                        { field: "birthdate", label: "Fecha de nacimiento", placeholder: "dd/mm/aaaa" },
                        { field: "terms", label: "He leído y acepto los", termsText: "términos y condiciones.", termsLink: "#" },
                        // { field: "privacy", label: "Acepto el uso y", privacyText: "tratamiento de datos personales.", privacyLink: "/tratamiento-datos-personales" }
                      ]}
                      buttonText="Comienza a participar"
                      background="#fff"
                      autologin={autologin}
                      hash={hash}
                      // extraLoginPreloader={extraLoginPreloader}
                      // setExtraLoginPreloader={setExtraLoginPreloader}
                      link={link}
                    />
                  }
                  {tabIndex === 1 &&
                    <div className='participar-steps-container'>
                      <h4>
                        Gana así
                      </h4>
                      <p>
                        Paga todas tus compras con tu Tarjeta Éxito Mastercard o Carulla Mastercard del 15 de abril al 15 de junio de 2026.
                      </p>
                      <h5>
                        Paso a paso
                      </h5>
                      <Slider {...sliderStepsSettings}>
                        {slidesSteps.map((step, index) => {
                          return (
                            <div key={index} className={`participar-steps__items--item`}>
                              <div className='participar-steps__items--item--desc'>
                                <span className='number-big'>{step.number}</span>
                                <div>
                                  <h6>
                                    {step.title}
                                  </h6>
                                  <p dangerouslySetInnerHTML={{ __html: step.desc }} />
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </Slider>
                    </div>
                  }
                </div>
              </div>
            </Container>
          </>
          : <>
            <Container className="full-height width-disable">
              <div className='login-form-container'>
                <h1>
                  <span className='span-type-1'>Para tooodo lo que quieres</span>
                  <span className='span-type-2'>usa tu Tarjeta Éxito</span>
                  <span className='span-type-2'> o Carulla Mastercard</span>
                  {/* <span className='span-type-2'>Carulla Mastercard</span> */}
                </h1>
                <div className='tabs-container'>
                  <section className="section-tab-login">
                    <article>
                      <div className="tab items">
                        {tabs.map((tab, idx) => (
                          <div
                            key={tab.label}
                            className={`tab-item ${tabIndex === idx ? 'active' : ''}`}
                            onClick={() => handleTabClick(idx, tab)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') handleTabClick(tab.key);
                            }}
                            aria-selected={tabIndex === idx}
                          >
                            {tab.image
                              ? <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                <img src={tabIndex === idx ? tab.image_active : tab.image} alt={`${tab.label} icon`} /> {tab.label}
                              </h3>
                              : <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                {tab.label}
                              </h3>
                            }

                          </div>
                        ))}
                      </div>
                    </article>
                  </section>
                </div>
                {tabIndex === 0 &&
                  <LoginForm
                    title={"¡Ingresa y participa!"}
                    type="credentials"
                    fields={[
                      { field: "code", label: "Introduce el código recibido por correo", placeholder: "Escribe tu código", maxlength: 6, separated: false, tooltip: "<strong>¿Dónde encuentro mi código?</strong><br/>Revisa tu correo o celular para encontrar el código de ingreso."},
                      { field: "birthdate", label: "Fecha de nacimiento", placeholder: "dd/mm/aaaa" },
                      { field: "terms", label: "He leído y acepto los", termsText: "términos y condiciones.", termsLink: "/terminos-y-condiciones" },
                      // { field: "privacy", label: "Acepto el uso y", privacyText: "tratamiento de datos personales.", privacyLink: "/tratamiento-datos-personales" }
                    ]}
                    buttonText="Comienza a participar"
                    background="#fff"
                    autologin={autologin}
                    hash={hash}
                  // extraLoginPreloader={extraLoginPreloader}
                  // setExtraLoginPreloader={setExtraLoginPreloader}
                  />
                }
                {tabIndex === 1 &&
                  <div className='participar-steps-container'>
                    <h4>
                      Gana así
                    </h4>
                    <p>
                      Paga todas tus compras con tu Tarjeta Éxito Mastercard o Carulla Mastercard del 15 de abril al 15 de junio de 2026.
                    </p>
                    <h5>
                      Paso a paso
                    </h5>
                    <Slider {...sliderStepsSettings}>
                      {slidesSteps.map((step, index) => {
                        return (
                          <div key={index} className={`participar-steps__items--item`}>
                            <div className='participar-steps__items--item--desc'>
                              <span className='number-big'>{step.number}</span>
                              <div>
                                <h6>
                                  {step.title}
                                </h6>
                                <p dangerouslySetInnerHTML={{ __html: step.desc }} />
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </Slider>
                  </div>
                }
              </div>
            </Container>
          </>
        }

      </div>
      <section className="mc-login__majorAward" id='login-slider'>
        <div className="awards__grid">
          {/* ====== LADO IZQUIERDO (título + íconos + banner) ====== */}
          <aside className="awards__intro">
            <h2 className="h2" style={{ margin: 0 }}>
              Descubre todo<br /> lo que puedes ganar
            </h2>
            <p style={{ marginTop: 8, marginBottom: 14 }}>
              Te mostramos todos los premios disponibles.
            </p>
            <img className='cata' src="/assets/images/categorias2.png" alt="" />

            <p style={{ fontWeight: 700, margin: '18px 0 10px' }}>
              Cada compra con tu Tarjeta te acerca a <br />
              ganar un carro y muchos premios más.
            </p>

            {/* Si usarás una sola imagen con los 4 íconos, deja solo este <img /> */}
            {/* <img src="/assets/premios/iconos-strip.png" alt="Iconos premios" width="220" height="48" /> */}

            {/* Si los manejas por separado, deja la UL */}
            {/* <ul className="awards__icons" aria-label="Categorías de premios">
              <li><img src="/assets/premios/icon-car.svg" alt="Auto" width="42" height="42" /></li>
              <li><img src="/assets/premios/icon-moto.svg" alt="Moto" width="42" height="42" /></li>
              <li><img src="/assets/premios/icon-market.svg" alt="Mercado" width="42" height="42" /></li>
              <li><img src="/assets/premios/icon-card.svg" alt="Bonos" width="42" height="42" /></li>
            </ul> */}

          </aside>

          {/* ====== LADO DERECHO (slider vertical 2 columnas) ====== */}
          
          <div className="awards__cardsPager">
            <div className='bg-custom-alliances'>
              <section className='SliderPlanSection slider-container-alliances'>
                <article className={`main-slider ${isFirstSlide ? 'is-first-slide' : ''}`}>
                  <div className="slider-container-alliances_slider scroll-here">
                    <Slider ref={sliderRef} {...settings}>
                      {list.map((item, i) => (
                        <div className='card-planSlider' key={i}>
                          <div className="banner">
                            <img src={`/assets/mayor-award/${item.img}`} alt={item.title} />
                          </div>
                          <div className="card-content-plan-slider">
                            <h4 dangerouslySetInnerHTML={{ __html: item.title }} />
                            <h5>
                              <div onClick={handleClick} dangerouslySetInnerHTML={{ __html: item.desc }} />
                            </h5>

                            <ul>
                              {item.benefits.map((benefit, i) => (
                                <li key={i}>
                                  <span className={`icon-slider-plan`}><Icon name={benefit.icon} /></span>
                                  <p>{benefit.name}</p>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </article>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className="benefits-hero" role="region" aria-label="Beneficios campaña">
        <div className="bh__grid">
          <h2 className="bh__title">
            Entre más compres en tus<br />comercios favoritos, ¡más<br />cerca estarás de ganar!
          </h2>

          <img
            className="bh__cards"
            src="/assets/images/Tarjetas1.png"
            alt="Tarjetas Éxito y Carulla"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  )
}
export default Login